/**
 * @file コンポーネント：フル動画ページ機器広告スライダー ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnSetFixedBody } from "~/src/functions/common";

// コンポーネントを返す
export const SliderAd = (props) => {
    /**
     * 初期スライド位置
     */
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        if (Number.isInteger(props.defaultIndex) && props.defaultIndex >= 0) {
            setCurrentIndex(props.defaultIndex);
        }
    }, [props.defaultIndex]);

    /**
     * ズーム機能
     */
    const [isZoom, setIsZoom] = useState(false);
    useEffect(() => {
        fnSetFixedBody(isZoom);
    }, [isZoom]);

    /**
     * スライド画像サイズ設定
     */
    const [magnifications, setMagnifications] = useState([]);
    // スライド画像のデフォルトの倍率をセット
    useEffect(() => {
        setMagnifications([...Array(props.list.length)].map(() => 100));
    }, [props.list]);
    // スライド画像のサイズ処理
    const refSliderContentlist = useRef(null);
    const refSliderContentlistItem = useRef(null);
    useEffect(() => {
        const currentItem = refSliderContentlistItem.current;
        const currentItemImage = refSliderContentlistItem.current?.children[0];
        const currentItemPrevSibling =
            refSliderContentlistItem.current?.previousElementSibling;
        const currentItemNextSibling =
            refSliderContentlistItem.current?.nextElementSibling;

        if (currentItemImage) {
            if (!isZoom) {
                // スライド視覚整形リセット
                currentItem.style.display = null;
            } else {
                // スライド画像サイズ
                currentItemImage.style.maxHeight = null;
                currentItemImage.style.maxWidth = null;
                currentItemImage.style.width =
                    magnifications[currentIndex] + "%";

                // スライド視覚整形
                const imageHeight = currentItemImage.offsetHeight;
                const imageWidthRate = magnifications[currentIndex];
                const itemHeight = currentItem.offsetHeight;
                const itemWidthRate = 100;

                if (
                    imageWidthRate <= itemWidthRate &&
                    imageHeight <= itemHeight
                ) {
                    // スライド画像が画面内に収まっている場合
                    currentItem.style.display = "flex";
                } else if (
                    imageWidthRate <= itemWidthRate &&
                    imageHeight > itemHeight
                ) {
                    // スライド画像が縦のみ画面より大きい場合
                    currentItem.style.display = "block";
                } else if (
                    imageWidthRate > itemWidthRate &&
                    imageHeight <= itemHeight
                ) {
                    // スライド画像が横のみ画面より大きい場合
                    currentItem.style.display = "block";
                } else {
                    // スライド画像が縦、横ともに画面より大きい場合
                    currentItem.style.display = "block";
                }

                // スクロール位置調整（拡大縮小時に上下真ん中に自動スクロール）
                const imageWidth = currentItemImage.offsetWidth;
                const itemWidth = currentItem.offsetWidth;
                const listHeight = refSliderContentlist.current.offsetHeight;
                const scrollX = (imageWidth - itemWidth) / 2;
                const scrollY = (imageHeight - listHeight) / 2;
                refSliderContentlist.current.scrollLeft = scrollX;
                refSliderContentlist.current.scrollTop = scrollY;
            }
            if (currentItemPrevSibling) {
                currentItemPrevSibling.style.display = null;
            }
            if (currentItemNextSibling) {
                currentItemNextSibling.style.display = null;
            }
        }
    }, [
        currentIndex,
        isZoom,
        magnifications,
        refSliderContentlistItem.current,
    ]);

    /**
     * スライド画像ズームイン処理
     */
    const fnZoomInSlide = (currentSlide = currentIndex) => {
        if (magnifications[currentSlide] < 200) {
            // 倍率設定
            setMagnifications((prevState) =>
                prevState.map((state, i) =>
                    i === currentSlide ? state + 25 : state
                )
            );
        }
    };

    /**
     * スライド画像ズームアウト処理
     */
    const fnZoomOutSlide = (currentSlide = currentIndex) => {
        if (magnifications[currentSlide] > 50) {
            // 倍率設定
            setMagnifications((prevState) =>
                prevState.map((state, i) =>
                    i === currentSlide ? state - 25 : state
                )
            );
        }
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            currentIndex={currentIndex}
            fnZoomInSlide={fnZoomInSlide}
            fnZoomOutSlide={fnZoomOutSlide}
            isZoom={isZoom}
            magnifications={magnifications}
            refSliderContentlist={refSliderContentlist}
            refSliderContentlistItem={refSliderContentlistItem}
            setCurrentIndex={setCurrentIndex}
            setIsZoom={setIsZoom}
        />
    );
};
